import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: easing }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal. Pass an array of strings.
export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.15em] -mb-[0.15em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.12, ease: easing }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs uppercase tracking-luxury text-zinc-500 font-semibold ${className}`}
  >
    <span className="h-px w-8 bg-gold/60" />
    {children}
  </span>
);
